export const aside_zh = {
    menu: {
        onchain: "链上数据",
        onchain1: "大额交易",
        onchain2: "地址统计",
        onchain3: "区块实时交易量",
        onchain4: "日交易详情",
        onchain5: "地址数分布",
        onchain5I:"(余额)地址数分布",
        onchain6: "币数量分布",
        onchain6I: "(余额)币数量分布",
        onchain7: "地址数分布",
        onchain7I: "(时间)地址数分布",
        onchain8: "币数量分布",
        onchain8I: "(时间)币数量分布",
        onchain9: "地址数分布",
        onchain9I: "(价格)地址数分布",
        onchain10: "币数量分布",
        onchain10I: "(价格)币数量分布",
        onchain11: "地址数分布",
        onchain11I: "(价差)地址数分布",
        onchain12: "币数量分布",
        onchain12I: "(价差)币数量分布",
        onchain13: "地址数分布",
        onchain13I: "(盈利)地址数分布",
        onchain14: "币数量分布",
        onchain14I: "(盈利)币数量分布",
        onchain15: "巨鲸地址列表",
        onchain16: "巨鲸交易监控",
        onchain17: "币价当前市值排名",
        coinmarketall: "币价当前市值排名",
        onchain18: "地址对应标记持有者名称关系列表",
        onchain19: "交易统计",
        onchain20: "矿工余额",
        onchain21: "矿工余额",
        technology: "技术指标",
        technology1: "MVRV Ratio",
        mvrv: "MVRV Ratio",
        technology2: "MVRV Z-Score",
        technology3: "NVTRatio",
        technology4: "NVTSignal",
        technology5: "日K线",
        technology6: "江卓尔60日累计涨幅",
        jzr60: "江卓尔60日累计涨幅",
        technology7: "arh999囤币及逃顶指标",
        arh999: "arh999囤币及逃顶指标",
        technology8: "天针",
        technology9: "ETF持有比特币",
        technology10: "ETF比特币变动",
        technology11: "2年移动平均价格乘数",
        ma730: "2年移动平均价格乘数",
        technology12: "已实现流通市值",
        technology13: "资金费率",
        technology14: "未平仓合约数",
        technology15: "合约主动买入量",
        technology16: "每日已实现盈利交易占比",
        technology17: "已花费输出盈利比",
        SOPR: "已花费输出盈利比",
        technology18: "已花费输出平均寿命",
        asol: "已花费输出平均寿命",
        technology19: "已花费输出休眠平均天数",
        technology20: "币天销毁量年龄分布",
        soag: "币天销毁量年龄分布",
        technology21: "流通供应量",
        technology22: "累计币天销毁量(流通供应量）",
        technology23: "累计币天销毁量",
        technology24: "活跃度",
        technology25: "已实现盈利量",
        technology26: "已实现亏损量",
        technology27: "已实现净收益损失比",
        technology28: "流通市值",
        marketcap: "流通市值",
        technology29: "已实现流通市值",
        rcap: "已实现流通市值",
        technology30: "长期持有者 MVRV Ratio",
        lthmvrv: "长期持有者 MVRV Ratio",
        technology31: "短期持有者 MVRV Ratio",
        sthmvrv: "短期持有者 MVRV Ratio",
        technology32: "未实现的净收益损失比",
        nupl: "未实现的净收益损失比",
        technology33: "未实现的净收益量",
        technology34: "未实现的净亏损量",
        technology35: "长持者未实现的净收益损失比",
        lthnupl: "长持者未实现的净收益损失比",
        technology36: "短持者未实现的净收益损失比",
        sthnupl: "短持者未实现的净收益损失比",
        technology37: "币天销毁量",
        CDD: "币天销毁量",
        macro: "宏观经济指标",
        macro1: "纳斯达克指数",
        macro2: "纳斯达克指数 vs BTC",
        exchange: "交易所数据",
        exchange1: "合约K线",
        exchange2: "交易量",
        address: "地址",
        address1: "活动地址",
        address2: "每日活跃地址数",
        address3: "每日发起交易地址数",
        address4: "每日收到交易地址数",
        address5: "新增地址",
        address6: "每日新增地址数",
        address7: "地址总数",
        transactions: "交易汇总",
        transactions1: "交易规模",
        transactions2: "每天交易规模",
        transactions3: "每秒交易规模",
        transactions4: "交易量",
        transactions5: "成交次数",
        transactions6: "日成交率",
        Distribution: "分配数据",
        Distribution1: "地址余额 ≥0.1",
        Distribution2: "地址余额 ≥0.01",
        Distribution3: "地址余额 ≥1",
        Distribution4: "地址余额 ≥10 ",
        Distribution5: "地址余额 ≥100",
        Distribution6: "地址余额 ≥1000",
        Distribution7: "地址余额 ≥10000 ",
        derivatives: "主要交易所衍生数据",
        derivatives1: "具体数据",
        derivatives2: "交易所日交易量",
        derivatives3: "交易所笔数变动",
        // Currency: "持有者币龄地址数/币数量分布图", 删除
        Currency1: "持有者地址数详细分布(按持有时间分段)",
        Currency2: "余额<0.01",
        Currency2I: "(地址)余额<0.01",
        balanceData1: "余额<0.01",
        Currency3: "余额>=0.01 & < 0.1",
        Currency3I: "(地址)余额>=0.01 & < 0.1",
        balanceData2: "余额>=0.01 & < 0.1",        
        Currency4: "余额>=0.1 & < 1",
        Currency4I: "(地址)余额>=0.1 & < 1",
        balanceData3: "余额>=0.1 & < 1",
        Currency5: "余额>=1 & < 10",
        Currency5I: "(地址)余额>=1 & < 10",
        balanceData4: "余额>=1 & < 10",
        Currency6: "余额>=10 & < 100",
        Currency6I: "(地址)余额>=10 & < 100",
        balanceData5: "余额>=10 & < 100",
        Currency7: "余额>=100 & < 1000",
        Currency7I: "(地址)余额>=100 & < 1000",
        balanceData6: "余额>=100 & < 1000",
        Currency8: "余额>=1000 & < 10000",
        Currency8I: "(地址)余额>=1000 & < 10000",
        balanceData7: "余额>=1000 & < 10000",
        Currency9: "余额>=10000",
        Currency9I: "(地址)余额>=10000",
        balanceData8: "余额>=10000",
        Currency10: "持有者币数量详细分布(按持有时间分段)",
        Currency11: "余额<0.01",
        Currency11I: "(币数量)余额<0.01",
        balanceData9: "余额<0.01",
        Currency12: "余额>=0.01 & < 0.1",
        Currency12I: "(币数量)余额>=0.01 & < 0.1",
        balanceData10: "余额>=0.01 & < 0.1",
        Currency13: "余额>=0.1 & < 1",
        Currency13I: "(币数量)余额>=0.1 & < 1",
        balanceData11: "余额>=0.1 & < 1",
        Currency14: "余额>=1 & < 10",
        Currency14I: "(币数量)余额>=1 & < 10",
        balanceData12: "余额>=1 & < 10",
        Currency15: "余额>=10 & < 100",
        Currency15I: "(币数量)余额>=10 & < 100",
        balanceData13: "余额>=10 & < 100",
        Currency16: "余额>=100 & < 1000",
        Currency16I: "(币数量)余额>=100 & < 1000",
        balanceData14: "余额>=100 & < 1000",
        Currency17: "余额>=1000 & < 10000",
        Currency17I: "(币数量)余额>=1000 & < 10000",
        balanceData15: "余额>=1000 & < 10000",
        Currency18: "余额>=10000",
        Currency18I: "(币数量)余额>=10000",
        balanceData16: "余额>=10000",
        large: "大额交易数据",
        large1: "USDT大额交易监控",
        large2: "USDC大额交易监控",
        large5: "BUSD大额监控",
        large3: "USDT日交易量",
        large4: "USDC日交易量",
        interval: "1月",
        interval1: "历史数据",
        interval2: "1周",
        interval3: "1天",
        interval4: "5分钟",
        interval5: "无",
        interval6: "1周及实时数据",
        interval7: "默认1天,可根据选择时间间隔查询",
        interval8: "选择交易对查询",
        interval9: "通过查询时间间隔显示数据,默认5分钟",
        interva20: "折线图:1月数据,表格:2天",
        interva21: "条件查询显示",
        interva22: "折线图:1月数据,表格:1周",
        interva23: "所有数据 无时间线", 
        interva24:"8小时",
        technology38:"Puell Multiple",
        market:"市场指标",
        nonChain:"非链数据",
        transactionMonitoring:"大额交易监控",
        holders:"持有者分布",
        circulation:"流通量",
        profitAddress:"盈利地址数",
        lossAddress:"亏损地址数",
        profitRatio:"地址盈亏比",
        lthSupply:"长期持有者供应量",
        lthSupply2:"长期持有者供应量",
        sthSupply:"短期持有者供应量",
        sthSupply2:"短期持有者供应量",
        realizedPrice:"已实现价格",
        relativeLthSth:"长/短期持有者供应量盈亏比",
        relativeLthSth2:"长/短期持有者供应量盈亏比",
        lthProfitSupply:"长期持有者盈利供应量",
        lthProfitSupply2:"长期持有者盈利供应量",
        lthLossSupply:"长期持有者亏损总供应量",
        lthLossSupply2:"长期持有者亏损总供应量",
        sthProfitSupply:"短期持有者盈利供应量",
        sthProfitSupply2:"短期持有者盈利供应量",
        sthLossSupply:"短期持有者亏损供应量",
        sthLossSupply2:"短期持有者亏损供应量",
        sthProfitRatio:"短期持有者盈亏比",
        sthProfitRatio2:"短期持有者盈亏比",
        SLRVRatio:"短期到长期实现价值比率",
        SLRVRatio2:"短期到长期实现价值比率",
        lthProfitRatio:"长期持有者盈亏比",
        lthProfitRatio2:"长期持有者盈亏比",
        lthVolume:"长期持有者每日交易量",
        lthVolume2:"长期持有者每日交易量",
        frm:"交易汇率乘数",
        cvdd:"累积价值-销毁天数比",
        cvdd2:"累积价值-销毁天数比",
        balancedPrice:"已平衡价格",
        nvtRatio:"市盈率",
        nvtRatio2:"市盈率",
        velocity:"流通速度",
        holderAddress:"持有者地址数分布",
        upgrade:"升级账户",
        PiCycleTopIndicator:"PI周期顶指标",
        ssr:"稳定币供应比",
        ssro:"稳定币供应比振荡器",
        stfRatio:"库存/新发行比",
        stfDeflection:"库存/新发行偏差",
        goldenRatioMult:"黄金比例乘数",
        Miners:"矿工",
        Network:"网络",
        LongShort:"长/短期持有者",
        ProfitLoss:"盈亏",
        Lifetime:"币龄",
        Ratio:"比率",
        Holder:"持有者分布",
        balanceGroup:"按余额划分",
        timeGroup:"按持有时间划分",       
        priceGroup:"按买入价格划分",
        PriceDifference:"按买卖价差划分",
        profitGroup:"按盈利划分",
        addressGroup:"地址详细分布",
        CoinQuantity:"币数量详细分布",
        earcap:"已实现流通市值(找零消除)",  
        earcap2:"已实现流通市值(找零消除)",
        btcBalance:"交易所余额",
        tzbp:"时区购买力",
        bobp:"买入大单挂单",
        bosp:"卖出大单挂单",
        volumeProfile:"成交量分布图",
        exchange10:"交易所余额",
        dataMonitoring:"访问统计",
        quickNews:"市场快讯",
        economics:"财经日历",
        currencyBTC:"BTC",
        currencyETH:"ETH",
        Stablecoin:"稳定币",
        mempool:"待交易池详情",
        nvtSign:"NVT信号",
        homePage:"首页",
        USTreasuriesYields:"国债收益率",
        MoneyStockMeasures:"货币供应量",
        loanPsi:"私营部门贷款",
        loanGdp:"私人债务占GDP比重",
        wei:"每周经济指数",
        distributionLthSth:"长/短期持有者供应量盈亏分布",
        macroscopic:"宏观经济(美国)",
        other:"其他",
        BTCMenu:"BTC",
        ETHMenu:"ETH",
        stableMenu:"稳定币",
        macroscopicMenu:"宏观经济指标",
        exchangeRate:"实时汇率",
        GDP:"GDP",
        newAddress:"新地址数",
        newAddressVolume:"新地址交易量",
        TransactionVolume:"交易量",
        adjusted:"交易量(找零消除)",
        TransactionFee:"交易费",
        totalAddress:"总地址数",
        minerBalance:"矿工地址余额",
        minerAddress:"矿工地址数",
        TransactionCount:"交易内存池数量",
        memoryPoolFees:"交易内存池费用",
        saCDD:"币天销毁量(供应调整)",
        sadormancy:"已花费输出休眠平均天数(供应量调整)",
        sellRatio:"合约主动买入量(买卖比率)",
        balanceGroup2:"按余额划分地址数分布",
        currencyGroup:"按余额划分币数量分布",
        addressBalance:"余额 < 0.01",
        addressBalance1:"余额 >=0.01 & <0.1",
        addressBalance2:"余额 >=0.1 & <1",
        addressBalance3:"余额 >=1 & <10",
        addressBalance4:"余额 >=10 & <100",
        addressBalance5:"余额 >=100 & <1000",
        addressBalance6:"余额 >=1000 & <10000",
        addressBalance7:"余额 >=10000",
        currencyGroup1:"余额 < 0.01",
        currencyGroup2:"余额 >=0.01 & <0.1",
        currencyGroup3:"余额 >=0.1 & <1",
        currencyGroup4:"余额 >=1 & <10",
        currencyGroup5:"余额 >=10 & <100",
        currencyGroup6:"余额 >=100 & <1000",
        currencyGroup7:"余额 >=1000 & <10000",
        currencyGroup8:"余额 >=10000",
        activeAddresses:"活跃地址数",
        ReceiveAddresses:"接收地址数",
        SendAddresses:"发送地址数",
        USDCETH:"USDC On ETH大额交易",
        USDTETH:"USDT On ETH大额交易",
        vdd:"价值损毁天数倍数",
    },


};
export const aside_en = {
    menu: {
        onchain: "Onchain",
        onchain1: "Big Amount Transaction",
        onchain2: "Address Statistics",
        onchain3: "Block Real-time Trading Volume",
        onchain4: "Daily Transaction Details",
        onchain5: "Address Distribution of Holder",
        onchain5I:"(balance)Address Distribution of Holder",
        onchain6: "Supply Distribution of Holder",
        onchain6I: "(balance)Supply Distribution of Holder",
        onchain7: "Address Distribution of Holder",
        onchain7I: "(time)Address Distribution of Holder",
        onchain8: "Supply Distribution of Holder",
        onchain8I: "(time)Supply Distribution of Holder",
        onchain9: "Address Distribution of Holder",
        onchain9I: "(price)Address Distribution of Holder",
        onchain10: "Supply Distribution of Holder",//
        onchain10I: "(price)Supply Distribution of Holder",//
        onchain11: "Address Distribution of Holder",
        onchain11I: "(Price difference)Address Distribution of Holder",
        onchain12: "Supply Distribution of Holder",
        onchain12I: "(Price difference)Supply Distribution of Holder",
        onchain13: "Address Distribution of Holder",
        onchain13I: "(profit)Address Distribution of Holder",
        onchain14: "Supply Distribution of Holder",
        onchain14I: "(profit)Supply Distribution of Holder",
        onchain15: "Whale Address List",
        onchain16: "Whale trade monitoring",
        onchain17: "Makret Value of the Currency",
        coinmarketall:"The current market value of the currency",
        onchain18: "Addresses correspond to a relational list of tag holder names",
        onchain19: "Transaction statistics",
        onchain20: "Miner Balance",
        onchain21: "Miner Balance",
        technology: "Technical indicators",
        technology1: "MVRV Ratio",
        mvrv:"Market Value To Realized Value(MVRV) Ratio",
        technology2: "MVRV Z-Score",        
        technology3: "NVTRatio",
        technology4: "NVTSignal",
        technology5: "day K line",
        technology6: "Jiang Zhuoer 60-day Cumulative Gain",
        jzr60:"Jiang Zhuoer 60-day Cumulative Increase and Decrease",
        technology7: "ahr999 hoarding index",
        arh999:"ahr999 Hoarding and Escape Top Index",
        technology8: "Days needle",
        technology9: "ETF hold bitcoins",
        technology10: "ETF Bitcoin moves",
        technology11: "2-Year MA Multiplier",
        ma730:"2 Years Moving Average Price Multiplier",
        technology12: "Realized capitalization",
        technology13: "Funding Rate",
        technology14: "Number of Open Interest",
        technology15: "Perpetual By Active Buying",
        technology16: "Daily Percent UTXOs in Profit",
        technology17: "SOPR",
        SOPR:"Spent Output Profit Ratio (SOPR)",
        technology18: "ASOL",
        asol:"Average Spent Output Lifespan(ASOL)",
        technology19: "Dormancy",
        technology20: "Age distribution of CDD",
        soag:"Age distribution of Coin Days Destoryed(CDD)",
        technology21: "Circulating Supply",
        technology22: "Cumulative Circulating Supply",
        technology23: "Cumulative Coin Days Destroyed",
        technology24: "Liveliness",
        technology25: "Realized Profit",
        technology26: "Realized Loss",
        technology27: "Realized Profit/Loss Ratio",
        technology28: "Market Cap",
        marketcap:"Market Cap [USD]",
        technology29: "Realized Cap",
        rcap:"Realized Cap [USD]",
        technology30: "LTH MVRV",
        lthmvrv:"Long-Term Holder(LTH) MVRV",        
        technology31: "STH MVRV",
        sthmvrv:"Short-Term Holder (STH) MVRV",
        technology32: "NUPL",
        nupl:"Net Unrealized Profit/Loss(NUPL)",
        technology33: "Unrealized Profit",
        technology34: "Unrealized Loss",
        technology35: "LTH NUPL",
        lthnupl:"Long Term Holder NUPL",       
        technology36: "STH NUPL",
        sthnupl:"Short Term Holder NUPL",
        technology37: "CDD",
        CDD:"Coin Days Destoryed(CDD)",
        macro: "Macroeconomic Indicators",
        macro1: "NDAQ index",
        macro2: "NDAQ index Vs BTC",
        exchange: "Exchange Data",
        exchange1: "Contract K line",
        exchange2: "Trading volume",
        address: "Addresses",
        address1: "Activities address",
        address2: "Number of active addresses per day",
        address3: "Number of address initiates per day",
        address4: "Number of transaction addresses received per day",
        address5: "The new address",
        address6: "Number of newly added addresses per day",
        address7: "The total number of addresses",
        transactions: "The transactions",
        transactions1: "deals The size of the ",
        transactions2: "Daily trading size",
        transactions3: "Transaction size per second",
        transactions4: "Trading volume",
        transactions5: "Clinch a deal the number",
        transactions6: "Day of closing",
        Distribution: "Distribution of data",
        Distribution1: "Address the balance ≥0.1",
        Distribution2: "Address the balance ≥0.01",
        Distribution3: "Address the balance ≥1",
        Distribution4: "Address the balance ≥10 ",
        Distribution5: "Address the balance ≥100",
        Distribution6: "Address the balance ≥1000",
        Distribution7: "Address the balance ≥10000 ",
        derivatives: "Major exchange derivatives data",
        derivatives1: "The specific data",
        derivatives2: "Daily exchange volume",
        derivatives3: "Changes in the number of transactions",
        Currency: "Distribution map of address number of holder coin age/coin quantity",
        Currency1: "Detailed Distribution of Holder addresses (by time held)",
        Currency2: "The balance of>=0 and <0.01",
        Currency2I: "(address)The balance of>=0 and <0.01",
        balanceData1:"Address Distribution(The balance of>=0 and <0.01)",
        Currency3: "The balance of>=0.01 and <0.1",
        Currency3I: "(address)The balance of>=0.01 and <0.1",
        balanceData2:"Address Distribution(The balance of>=0.01 and <0.1)",
        Currency4: "The balance of>=0.1 and <1",
        Currency4I: "(address)The balance of>=0.1 and <1",
        balanceData3:"Address Distribution(The balance of>=0.1 and <1)",
        Currency5: "The balance of>=1 and <10",
        Currency5I: "(address)The balance of>=1 and <10",
        balanceData4:"Address Distribution(The balance of>=1 and <10)",
        Currency6: "The balance of>=10 and <100",
        Currency6I: "(address)The balance of>=10 and <100",
        balanceData5:"Address Distribution(The balance of>=10 and <100)",
        Currency7: "The balance of>=100 and <1000",
        Currency7I: "(address)The balance of>=100 and <1000",
        balanceData6:"Address Distribution(The balance of>=100 and <1000)",
        Currency8: "The balance of>=1000 and <10000",
        Currency8I: "(address)The balance of>=1000 and <10000",
        balanceData7:"Address Distribution(The balance of>=1000 and <10000)",
        Currency9: "The balance of>=10000",
        Currency9I: "(address)The balance of>=10000",
        balanceData8:"Address Distribution(The balance of>=10000)",
        Currency10: "Detailed distribution of the number of holders' coins (by holding time)",
        Currency11: "The balance of>=0 and <0.01",
        Currency11I: "(Number of coins)The balance of>=0 and <0.01",
        balanceData9:"Supply Distribution(The balance of>=0 and <0.01)",
        Currency12: "The balance of>=0.01 and <0.1",
        Currency12I: "(Number of coins)The balance of>=0.01 and <0.1",
        balanceData10:"Supply Distribution(The balance of>=0.01 and <0.1)",
        Currency13: "The balance of>=0.1 and <1",
        Currency13I: "(Number of coins)The balance of>=0.1 and <1",
        balanceData11:"Supply Distribution(The balance of>=0.1 and <1)",
        Currency14: "The balance of>=1 and <10",
        Currency14I: "(Number of coins)The balance of>=1 and <10",
        balanceData12:"Supply Distribution(The balance of>=1 and <10)",
        Currency15: "The balance of>=10 and <100",
        Currency15I: "(Number of coins)The balance of>=10 and <100",
        balanceData13:"Supply Distribution(The balance of>=10 and <100)",
        Currency16: "The balance of>=100 and <1000",
        Currency16I: "(Number of coins)The balance of>=100 and <1000",
        balanceData14:"Supply Distribution(The balance of>=100 and <1000)",
        Currency17: "The balance of>=1000 and <10000",
        Currency17I: "(Number of coins)The balance of>=1000 and <10000",
        balanceData15:"Supply Distribution(The balance of>=1000 and <10000)",
        Currency18: "The balance of>=10000",
        Currency18I: "(Number of coins)The balance of>=10000",
        balanceData16:"Supply Distribution(The balance of>=10000)",
        large: "Large transaction data",
        large1: "USDT large transaction monitoring",
        large2: "USDC large transaction monitoring",
        large3: "Daily trading volume of USDT",
        large4: "Daily trading volume of USDC",
        interval: "Last month",
        interval1: "The historical data",
        interval2: "week",
        interval3: "day",
        interval4: "5 minutes",
        interval5: "There is no",
        interval6: "1 week and real-time data",
        interval7: "The default is 1 day, which can be queried according to the selected time interval",
        interval8: "Select transaction pair query",
        interval9: "Display data through the query interval. Default is 5 minutes.",
        interva20: "Line chart: January data, table: 2 days",
        interva21: "Conditional query display",
        interva22: "Line chart: January data, table: 1 week",
        interva23: "All data has no time line",
        interva24:"8 hours",
        technology38:"Puell Multiple",
        market:"Market Indicators",
        nonChain:"Off link data",
        transactionMonitoring:"Large transaction monitoring",
        holders:"Distribution of holders",
        circulation:"Flux Of Circulation",
        profitAddress:"Address in Profit",
        lossAddress:"Address in Loss",
        profitRatio:"Percent of Address in Profit",
        lthSupply:"Total Supply Held by LTH",
        lthSupply2:"Total Supply Held by Long-Term Holders(LTH)",
        sthSupply:"Total Supply Held by STH",
        sthSupply2:"Total Supply Held by Short-Term Holders(STH)",
        realizedPrice:"Realized Price",
        lthProfitSupply:"Total Supply in Profit Held by LTH",
        lthProfitSupply2:"Total Supply in Profit Held by Long-Term Holders(LTH)",
        lthLossSupply:"Total Supply in Loss Held by LTH",
        lthLossSupply2:"Total Supply in Loss Held by Long-Term Holders(LTH)",
        sthProfitSupply:"Total Supply in Profit Held by STH",
        sthProfitSupply2:"Total Supply in Profit Held by Short-Term Holders(STH)",
        sthLossSupply:"Total Supply in Loss Held by STH",
        sthLossSupply2:"Total Supply in Loss Held by Short-Term Holders(STH)",
        sthProfitRatio:"STH Profit/Loss Ratio",
        sthProfitRatio2:"Short-Term Holder (STH) Profit/Loss Ratio",
        SLRVRatio:"SLRV Ratio",
        SLRVRatio2:"Short to Long-Term Realized Value (SLRV) Ratio",
        lthProfitRatio:"LTH Profit/Loss Ratio",
        lthProfitRatio2:"Long-Term Holder (LTH) Profit/Loss Ratio",
        relativeLthSth:"LTH/STH Supply in Profit/Loss",
        relativeLthSth2:"Long- and Short-Term Holder Supply in Profit/Loss",
        lthVolume:"LTH Daily Volume",
        lthVolume2:"Long-Term Holder(LTH) Daily Volume",
        frm:"Fee Ratio Multiple(FRM)",
        cvdd:"CVDD",
        cvdd2:"Cumulative Value-Days Destroyed (CVDD)",
        balancedPrice:"Balanced Price",
        nvtRatio:"NVT Ratio",
        nvtRatio2:"Network Value to Transactions(NVT) Ratio",
        velocity:"Velocity",
        holderAddress:"Holder address number distribution",
        upgrade:"Upgrade Plan",
        piCycleTopIndicator:"Pi Cycle Top Indicator",
        ssr:"Stablecoin Supply Ratio (SSR)",
        ssro:"Stablecoin Supply Ratio (SSR) Oscillator",
        stfRatio:"Stock-to-Flow Ratio",
        stfDeflection:"Stock-to-Flow Deflection",
        goldenRatioMult:"Golden Ratio Multiplier",
        Miners:"Miners",
        Network:"Network info",
        LongShort:"Long/Short Term",
        ProfitLoss:"Profit/Loss",
        Lifetime:"Coin lifespan",
        Ratio:"Ratio",
        Holder:"Holder",
        balanceGroup:"By Balance",
        timeGroup:"By Holding Time",       
        priceGroup:"By Buying Price",
        PriceDifference:"By Price Gap",
        profitGroup:"By Profit",
        addressGroup:"Address Detail",
        CoinQuantity:"Supply Detail",
        earcap:"Entity-adjusted Realized Cap",
        earcap2:"Entity-adjusted Realized Cap [USD]",  
        btcBalance:"Exchange Balance (BTC)",
        tzbp:"Buy Power for Time Zone",
        bobp:"Buy Power for Big Order",
        bosp:"Sell Power for Big Order",
        volumeProfile:"Volume Profile",
        PiCycleTopIndicator:"Pi Cycle Top Indicator",
        exchange10:"Exchange Balance",
        dataMonitoring:"Summary",
        quickNews:"Market News",
        economics:"Economic Calendar",
        currencyBTC:"BTC",
        currencyETH:"ETH",
        Stablecoin:"Stablecoin",
        mempool:"Mempool Transactions",
        nvtSign:"Network Value to Transactions Signal",
        homePage:"homePage",
        USTreasuriesYields:"TreasuriesYields",
        MoneyStockMeasures:"currency supply",
        loanPsi:"loans to private sector",
        loanGdp:"Private debt as a percentage of GDP",
        wei:"Weekly Economic Index",
        distributionLthSth:"LTH/STH Supply Distribution",
        macroscopic:"Macroeconomics (United States)",
        other:"other",
        BTCMenu:"BTC",
        ETHMenu:"ETH",
        stableMenu:"Stable currency",
        macroscopicMenu:"Macroeconomics",
        exchangeRate:"Real time exchange rate",
        GDP:"Gross Domestic Product",
        newAddress:"New Addresses",
        newAddressVolume:"New Addresses Volume",
        TransactionVolume:"Transactions Volume",
        adjusted:"Transactions Volume(Entity-Adjusted)",
        TransactionFee:"Transactions Fee",
        totalAddress:"Total Addresses",
        minerBalance:"Miner Balance",
        minerAddress:"Miner Addresses",
        TransactionCount:"Mempool Transactions Count",
        memoryPoolFees:"Mempool Transactions Fees",
        saCDD:"Supply-Adjusted CDD",
        sadormancy:"Supply-Adjusted Dormancy",
        sellRatio:"Perpetual By Active Buying(Buy & Sell Ratio)",
        balanceGroup2:"By Balance Address Distribution of Holder",
        currencyGroup:"By Balance Supply Distribution of Holder",
        addressBalance:"Balance < 0.01",
        addressBalance1:"Balance >=0.01 and Balance <0.1",
        addressBalance2:"Balance >=0.1 and Balance <1",
        addressBalance3:"Balance >=1 and Balance <10",
        addressBalance4:"Balance >=10 and Balance <100",
        addressBalance5:"Balance >=100 and Balance <1000",
        addressBalance6:"Balance >=1000 and Balance <10000",
        addressBalance7:"Balance >=10000",
        currencyGroup1:"Balance < 0.01",
        currencyGroup2:"Balance >=0.01 and Balance <0.1",
        currencyGroup3:"Balance >=0.1 and Balance <1",
        currencyGroup4:"Balance >=1 and Balance <10",
        currencyGroup5:"Balance >=10 and Balance <100",
        currencyGroup6:"Balance >=100 and Balance <1000",
        currencyGroup7:"Balance >=1000 and Balance <10000",
        currencyGroup8:"Balance >=10000",
        activeAddresses:"Active Addresses",
        ReceiveAddresses:"Receive Addresses",
        SendAddresses:"Send Addresses",
        USDCETH:"USDC(ETH) Big Amount Transaction",
        USDTETH:"USDT(ETH) Big Amount Transaction",
        vdd:"Value Days Destroyed (VDD) Multiple",

       
    },


};